import { MapOverlaySVGResult } from './svg-map-overlay-result'
import { MapOverlayContentProducer } from './map-overlay';
import { PixelProjection, GeodeticBounds } from './map-types';
import { replaceNodeContent } from '../dom/dom';

export class MapOverlaySVGContentProducer implements MapOverlayContentProducer {

	private svg: MapOverlaySVGResult;
	private svgContainerElem: SVGElement;

	constructor(private svgElemPreprocessor?: (svgElem: SVGElement, svg: MapOverlaySVGResult) => void) {
	}

	public setSVG(svg: MapOverlaySVGResult): void {
		this.svg = svg;
		this.svgContainerElem = this.svg ? this.svg.elem : undefined;
		if (this.svgContainerElem) {
			this.svgContainerElem.style.position = 'absolute';
		}
	}
	public getBounds(): GeodeticBounds {
		return this.svg;
	}

	public draw(container: HTMLElement, className: string, localProjection: PixelProjection): {
		elemId: string,
		dataIds: string[]
	}[] {

		if (container) {
			if (this.svgContainerElem) {
				let ne = localProjection.fromLatLngToPixel(this.svg.northEast);
				let sw = localProjection.fromLatLngToPixel(this.svg.southWest);
				if (className) {
					this.svgContainerElem.classList.add(className);
				}
				this.svgContainerElem.style.top = ne.y + 'px';
				this.svgContainerElem.style.left = sw.x + 'px';
				this.svgContainerElem.style.width = (ne.x - sw.x) + 'px';
				this.svgContainerElem.style.height = (sw.y - ne.y) + 'px';
				if (this.svgElemPreprocessor) {
					this.svgElemPreprocessor(this.svgContainerElem, this.svg);
				}
			}
			replaceNodeContent(container, this.svgContainerElem);
		}
		return undefined;
	}

}
